import React, { ReactNode } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./Title.module.scss";

interface IProps {
  children: ReactNode;
  className?: string;
  fontSize?: number;
  color?: string;
  fontFamily?:
    | "Poppins"
    | "Arial"
    | "Roboto"
    | "sans-serif"
    | "Helvetica"
    | "Open Sans"
    | "Montserrat"
    | "Lato"
    | "Georgia"
    | "Times New Roman"
    | "Courier New"
    | "Verdana"
    | "Tahoma"
    | "Noto Sans"
    | "Oswald"
    | "Merriweather";

  fontStyle?: "normal" | "italic" | "oblique";
  fontWeight?: "normal" | "bold" | "lighter" | "bolder" | number;
}

const PageTitle: React.FC<IProps> = (props: IProps) => {
  const {
    className = "text-center mb-3",
    fontSize = 20,
    color = "#1a3a68",
  } = props;
  return (
    <Row>
      <Col className={[className].join(" ")}>
        <h6
          className={[styles.title].join(" ")}
          style={{
            fontSize,
            color,
            fontFamily: props.fontFamily,
            fontStyle: props.fontStyle,
            fontWeight: props.fontWeight,
          }}
        >
          {props.children}
        </h6>
      </Col>
    </Row>
  );
};

export default PageTitle;
